import { Stack, Text, Flex } from '@backyard-ui/core';

import { Star } from '@/presenters/components/common/RatingStars/components/Star';

import { calculatePercentage } from '../utils/calculatePercentage';

import { RatingBar } from './RatingBar';

export interface ItemProps {
  value: number;
  totalReviewsCount: number;
  size: 'sm' | 'md';
  count: number;
}

export default function Item(props: ItemProps) {
  const { value, totalReviewsCount, size, count } = props;

  const percentage = calculatePercentage({ count, totalReviewsCount });

  return (
    <Stack
      justify="flex-start"
      align="center"
      spacing={2}
      data-testid="rating-resume-item"
    >
      <Flex
        justify="center"
        align="center"
        className="-my-1 flex w-4 justify-center"
        data-testid="rating-resume-value"
      >
        <Text weight="bold" size={size === 'sm' ? 'lg' : '3xl'} asChild>
          <span>{value}</span>
        </Text>
      </Flex>

      <Star decimals={1} />

      <RatingBar percentage={percentage} size={size} />

      <Flex
        justify="center"
        align="center"
        className="-my-1 flex w-4 justify-center"
        data-testid="rating-resume-count"
      >
        <Text size="lg" color="gray-600" asChild>
          <span>{count}</span>
        </Text>
      </Flex>
    </Stack>
  );
}
